import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import CostRevenueChart from "../components/Charts/CostRevenueChart";
import JobPerformance from "../components/Charts/JobPerformance";
import { pageRoutes } from "../routes/PageRoutes";
import { useNavigate } from "react-router-dom";
import SubHeader from "../components/SubHeader";
const CreateQuote = () => {
const navigate = useNavigate();
const [isToggle, setIsToggle] = useState(false);
const onHandleClick = () => {
setIsToggle(!isToggle);
};
return (
<div className="ct_dashbaord_bg">
   <div className={`ct_dashbaord_main ${isToggle == false && "ct_active"}`}>
   <Sidebar path="customer-requests" />
   <div className="ct_content_right">
      <Header onClick={onHandleClick} />
      <div class="ct_px_23 ct_mt_30 pb-5">
         <div className="ct_mb_30">
            <SubHeader />
         </div>


         <div class="row">
          <div class="col-lg-8 mb-3">
             <div className="ct_white_bg_1">
               <div className="form-group mb-3">
                                    <label className="form-label">
                                      Select Services 
                                    </label>
                                    <select
                                      className="form-control ct_input ct_transparent_input ct_pointer_curser"
                                     
                                    >
                                      <option value="">Select Services  </option>
                                        <option value=""> Boat Washing</option>
                                          <option value=""> Haul Out</option>
                                            <option value="">Hull Polishing & Waxing </option>
                                  
                                    </select>
                                  
                                  </div>
          </div>
        
      <div className="ct_white_bg_1 ct_mt_30">
        
            <div className="ct_text_dark ct_fs_18 ct_fw_600 mb-4">
              Added  Services
            </div>
           
        
    
     
               <div className="maintennce-service-wrapper d-grid gap-3">
                  <div className="service-row" >
                     <div className="service-left">
                        <div className="service-title ct_fs_16 ct_fw_700 ct_text_dark">
                           Boat Washing
                        </div>
                        <p className="service-desc ct_fs_14 ct_fw_400 ct_text_para mb-0">
                           Complete boat haul out and inspection
                        </p>
                     </div>
                     <div className="service-right">
                        <div className="price-block text-center">
                           <div className="price-label ct_fs_12 ct_fw_700 ct_text_para mb-1">
                              PRICE
                           </div>
                           <div className="price-value ct_fs_14 ct_fw_700">
                              <span className="dollar ct_text_para">
                              <i className="fa-solid fa-dollar-sign me-2"></i>
                              </span>
                              800
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="service-row" >
                     <div className="service-left">
                        <div className="service-title ct_fs_16 ct_fw_700 ct_text_dark">
                           Boat Washing
                        </div>
                        <p className="service-desc ct_fs_14 ct_fw_400 ct_text_para mb-0">
                           Complete boat haul out and inspection
                        </p>
                     </div>
                     <div className="service-right">
                        <div className="price-block text-center">
                           <div className="price-label ct_fs_12 ct_fw_700 ct_text_para mb-1">
                              PRICE
                           </div>
                           <div className="price-value ct_fs_14 ct_fw_700">
                              <span className="dollar ct_text_para">
                              <i className="fa-solid fa-dollar-sign me-2"></i>
                              </span>
                              800
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="service-row" >
                     <div className="service-left">
                        <div className="service-title ct_fs_16 ct_fw_700 ct_text_dark">
                           Boat Washing
                        </div>
                        <p className="service-desc ct_fs_14 ct_fw_400 ct_text_para mb-0">
                           Complete boat haul out and inspection
                        </p>
                     </div>
                     <div className="service-right">
                        <div className="price-block text-center">
                           <div className="price-label ct_fs_12 ct_fw_700 ct_text_para mb-1">
                              PRICE
                           </div>
                           <div className="price-value ct_fs_14 ct_fw_700">
                              <span className="dollar ct_text_para">
                              <i className="fa-solid fa-dollar-sign me-2"></i>
                              </span>
                              800
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
          
           
       
     
      </div>
       <div className="ct_white_bg_1 ct_mt_30">
               <div className="form-group mb-4">
                                    <label className="form-label">
                                     Total Labour cost
                                    </label>
                                    <input
                                      className="form-control ct_input ct_transparent_input "
                                      placeholder="0"
                                     
                                    />
                                     
                                  
                                  </div>
                                   <div className="form-group mb-4">
                                    <label className="form-label">
                                 Estimated duration
                                    </label>
                                    <input
                                      className="form-control ct_input ct_transparent_input "
                                      placeholder="0"
                                     
                                    />
                                     
                                  
                                  </div>
           <div className="form-group mb-4">
                                    <label className="form-label">
                               Terms
                                    </label>

                                    <textarea
                                    placeholder="Write here..."
                                    rows={4} className="form-control ct_input ct_transparent_input "></textarea>
                                  
                                     
                                  
                                  </div>       
                                    <div className="form-group mb-4">
                                    <label className="form-label">
                               Warranty
                                    </label>

                                    <textarea
                                    placeholder="Write here..."
                                    rows={4} className="form-control ct_input ct_transparent_input "></textarea>
                                  
                                     
                                  
                                  </div>
                                    <div className="form-group mb-4">
                                    <label className="form-label">
                               Additional Notes
                                    </label>

                                    <textarea
                                    placeholder="Write here..."
                                    rows={4} className="form-control ct_input ct_transparent_input "></textarea>
                                  
                                     
                                  
                                  </div>                        
          </div>
          </div>

          <div class="col-lg-4 mb-3">

            <h3 class="ct_text_dark ct_fs_22 ct_fw_600 mb-3">Quote Preview</h3>
               <div class="ct_white_bg_1">

                  <div class="d-flex justify-content-between flex-wrap gap-3 align-items-center mb-3">
                     <h6 class="ct_fs_14 ct_fw_500 ct_text_dark mb-0"> Total Service Amount: </h6>
                     <h6 class="ct_fs_14 ct_fw_600 ct_text_dark mb-0"> $1,400.00</h6>
                  </div>
                    <div class="d-flex justify-content-between flex-wrap gap-3 align-items-center mb-3">
                     <h6 class="ct_fs_14 ct_fw_500 ct_text_dark mb-0"> Total Labour cost: </h6>
                     <h6 class="ct_fs_14 ct_fw_600 ct_text_dark"> $1,400.00</h6>
                  </div>
                  <div class="d-flex justify-content-between flex-wrap gap-3 align-items-center">
                     <h6 class="ct_fs_16 ct_fw_700 ct_text_dark mb-0">TOTAL COST <span class="ct_fs_14 ct_fw_400 ct_text_dark fst-italic ct_text_para">Estimated</span></h6>
                     <h6 class="ct_fs_16 ct_fw_700 ct_text_theme mb-0"> $1,695.60 </h6>
                  </div>
                
               </div>


                <div class="ct_white_bg_1 ct_mt_20">

                
                  <div class="d-flex justify-content-between flex-wrap gap-3 align-items-center">
                     <h6 class="ct_fs_16 ct_fw_700 ct_text_dark mb-0">Estimated duration:
                        </h6>
                     <h6 class="ct_fs_16 ct_fw_700 ct_text_theme mb-0"> 4 Days </h6>
                  </div>
                
               </div>

                <div class="ct_white_bg_1 ct_mt_20">

                
                
                     <h6 class="ct_fs_16 ct_fw_700 ct_text_dark mb-3"> TERMS
                        </h6>

                        <ul className="ps-3">
                          <li className="ct_fs_14 ct_fw_400 ct_text_para mb-1">Service cost includes labour only</li>
                             <li className="ct_fs_14 ct_fw_400 ct_text_para mb-1">Parts will be charged separately</li>
                                <li className="ct_fs_14 ct_fw_400 ct_text_para mb-1">Timeline may vary after inspection</li>
                        </ul>
                    
                  
                
               </div>
               <div class="ct_white_bg_1 ct_mt_20">

                
                
                     <h6 class="ct_fs_16 ct_fw_700 ct_text_dark mb-3 text-uppercase"> Warranty:
                        </h6>

                        <ul className="ps-3">
                          <li className="ct_fs_14 ct_fw_400 ct_text_para mb-1">
                            7 days warranty on service
                            </li>
                             <li className="ct_fs_14 ct_fw_400 ct_text_para mb-1">
                              Warranty applies only to listed services
                              </li>
                                <li className="ct_fs_14 ct_fw_400 ct_text_para mb-1">Does not cover misuse or external damage</li>
                        </ul>
                    
                  
                
               </div>


                     <div class="ct_white_bg_1 ct_mt_20">

                
                
                     <h6 class="ct_fs_16 ct_fw_700 ct_text_dark mb-3 text-uppercase"> Additional Notes:
                        </h6>

                        <ul className="ps-3">
                          <li className="ct_fs_14 ct_fw_400 ct_text_para mb-0">
                           This quote includes labour only. Additional parts or repairs identified during inspection will be communicated and charged separately. Timeline may vary depending on the condition of the boat.
                            </li>
                           
                        </ul>
                    
                  
                
               </div>


               <div class="d-flex justify-content-center mt-4">
                  <button className="ct_orange_btn">
                   Create Quote and Send
                  </button>
               </div>
            </div>
         </div>
    
   </div>
</div>
</div>
</div>
);
};
export default CreateQuote;